import { supabase } from "@/lib/supabase/supabaseClient";
import { DeleteCrmConfigProps } from ".";

export const deleteCrmConfig = async (id: DeleteCrmConfigProps) => {
    return await supabase.from("crm_config").delete().eq("id", id);
}